import queryString from 'querystring';
// import reduxCreator from '../libs/mk-womanizer/redux-creator';
import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('ARTICLE').plugin(axiosPlugin);

let fetchArticleAction = redux.fetchActionGetOne();

let createArticleAction = redux.fetchActionCreate();

let updateArticleAction = redux.fetchActionUpdate();

let deleteArticleAction = redux.fetchActionDelete();

export const TYPES = redux.types;

export const fetchArticle = (articleId, query = {}) => fetchArticleAction(`/articles/${articleId}?${queryString.stringify(query)}`);
export const createArticle = (data = {}) => createArticleAction(`/articles`, data);
export const updateArticle = (articleId, data = {}) => updateArticleAction(`/articles/${articleId}`, data);
export const deleteArticle = (articleId = {}) => deleteArticleAction(`/articles/${articleId}`);
export const resetArticle = () => redux.actions.reset();

export const article = redux.reducer();